import React from "react";
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from "lucide-react";
import { Eyebrow } from "./Eyebrow";
import { EnquiryForm } from "./EnquiryForm";
const contacts = [{
  icon: PhoneIcon,
  label: "Call us",
  value: "+44 (0)20 0000 0000",
  href: "tel:+442000000000"
}, {
  icon: MailIcon,
  label: "Email",
  value: "hello@northgatelegal.co.uk",
  href: "mailto:hello@northgatelegal.co.uk"
}, {
  icon: MapPinIcon,
  label: "Office",
  value: "London, EC2",
  href: "#"
}];
export function Consultation() {
  return <section id="contact" className="w-full bg-cream px-6 py-[140px] lg:px-20" data-id="element-17" data-mp="3hubvnc6y1ry9">
      <div className="mx-auto max-w-page" data-id="element-18" data-mp="3lucct4lfgh90">
        <div className="grid grid-cols-12 gap-6" data-id="element-19" data-mp="3ltko8dq8zjs8">
          <div data-reveal className="col-span-12 lg:col-span-9" data-id="element-20" data-mp="3qm43rg8hwozo">
            <Eyebrow data-id="element-21" data-mp="3qnf75ey13uq9">Start a conversation</Eyebrow>
            <h2 className="mt-6 text-[48px] font-semibold leading-[0.98] tracking-[-0.045em] text-ink lg:text-[80px]" data-id="element-22" data-mp="2u2n07mytsnd3">
              Have a legal matter
              <br data-id="element-23" data-mp="1ghw8lhygpn2l" />
              <span className="text-stone" data-id="element-24" data-mp="1gie0y3i07h58">you’d like to discuss?</span>
            </h2>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6" data-id="element-25" data-mp="1bijd68tiz7oe">
          <aside data-reveal className="col-span-12 flex flex-col lg:col-span-4" data-id="element-26" data-mp="1bl5j640rpf4i">
            <p className="max-w-[340px] text-[17px] leading-[1.65] text-stone" data-id="element-27" data-mp="16pzwv43gdyfw">
              Tell us briefly what you need help with. A member of our team will review your enquiry
              and get back to you promptly.
            </p>

            <ul className="mt-10 border-t border-line" data-id="element-28" data-mp="srs3t79jfha0">
              {contacts.map(c => <li key={c.label} className="border-b border-line" data-id="element-29" data-mp="nsoydlpnb91i">
                  <a href={c.href} className="group flex items-center gap-4 py-5" data-id="element-30" data-mp="nv1qust151st">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full border border-line bg-white text-ink transition-colors duration-150 group-hover:border-accent group-hover:text-accent" data-id="element-31" data-mp="ivyj30lo0hh5">
                      <c.icon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-32" data-mp="2d6byjf5hhyg8" />
                    </span>
                    <span data-id="element-33" data-mp="g9pjntd4q5oh">
                      <span className="block text-[12px] text-stone" data-id="element-34" data-mp="g9xs9927yotv">{c.label}</span>
                      <span className="block text-[16px] font-semibold text-ink" data-id="element-35" data-mp="1lbg1g7w2d6v">{c.value}</span>
                    </span>
                  </a>
                </li>)}
            </ul>

            <div className="mt-auto flex items-center gap-3 pt-10 text-[14px] text-ink" data-id="element-36" data-mp="u8xj8nd7fft7">
              <span className="relative flex h-2.5 w-2.5" data-id="element-37" data-mp="z8a5b5w94iuq">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-40 motion-reduce:animate-none" data-id="element-38" data-mp="z7sbefx2agpz" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent" data-id="element-39" data-mp="pa47azdkfwv5" />
              </span>
              <ClockIcon className="h-4 w-4 text-stone" strokeWidth={1.75} aria-hidden="true" data-id="element-40" data-mp="3518rrtlp7t7b" />
              Typical response in under 2 hours
            </div>
          </aside>

          <div data-reveal data-reveal-delay="1" className="col-span-12 rounded-2xl border border-line bg-white p-8 md:p-12 lg:col-span-8" data-id="element-41" data-mp="1s2q38275mesg">
            <div className="mb-10 flex items-end justify-between gap-6" data-id="element-42" data-mp="1n33sbzestamt">
              <div data-id="element-43" data-mp="2146c25ibm8uk">
                <h3 className="text-[26px] font-semibold tracking-[-0.03em] text-ink" data-id="element-44" data-mp="212d7cvr9pyp7">Send an enquiry</h3>
                <p className="mt-1.5 text-[14px] text-stone" data-id="element-45" data-mp="1x3e2fb5je1xr">Takes around two minutes. No obligation.</p>
              </div>
            </div>
            <EnquiryForm data-id="element-46" data-mp="14ddxjcb1couw" />
          </div>
        </div>
      </div>
    </section>;
}